import { FC, useMemo } from 'react';
import { cn } from 'src/utils/utility';
import IconChartLine from 'src/presentations/components/atom/icons/ChartLine';
import IconChartBar from 'src/presentations/components/atom/icons/ChartBar';
import { CardAnalyticContent } from './CardAnalyticContent';
import { ChartType, ICardAnalyticItemProps } from './types';
import { getIconChartColor } from './cardStyles';

interface CardChartAnalyticProps {
  item: ICardAnalyticItemProps;
  isLoading: boolean;
  readOnly?: boolean;
  isEnable?: boolean;
  isActive?: boolean;
  hasError?: boolean;
}

export const CardChartAnalytic: FC<CardChartAnalyticProps> = ({ item, isLoading, readOnly, isEnable = true, isActive, hasError }) => {
  const { chartType = ChartType.LINE, theme } = item;

  const iconChartColor = useMemo(() => getIconChartColor({ theme, isActive, isEnable }), [isActive, isEnable, theme]);

  return (
    <CardAnalyticContent item={item} isLoading={isLoading} readOnly={readOnly} isEnable={isEnable} isActive={isActive} hasError={hasError}>
      {/* Chart Type Indicator - Always shown for chart variant */}
      <div className='flex items-center gap-[5px]'>
        {chartType === ChartType.LINE ? <IconChartLine color={iconChartColor} /> : <IconChartBar color={iconChartColor} />}
        <span className={cn("text-[12px] font-['Roboto']", isEnable ? 'text-[#808080]' : 'text-neutral-50')}>
          {chartType === ChartType.LINE ? 'Line' : 'Bar'}
        </span>
      </div>
    </CardAnalyticContent>
  );
};
